import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3nwax652hv: FaireBrandEntity = {
  token: "b_3nwax652hv",
  type: "brand",
  name: "Fond Regenerative",
  avatarUrl:
    "https://cdn.faire.com/fastly/795036569e22574166045c179985b08f0aaf458262e4436c6b7a8694ac0f2ff3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/871efe3dfb83386ecc24706628adbac186b593f15af70552803683c82fb2ddd4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/795036569e22574166045c179985b08f0aaf458262e4436c6b7a8694ac0f2ff3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/871efe3dfb83386ecc24706628adbac186b593f15af70552803683c82fb2ddd4.png",
  location: "Austin, TX, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 60,
  isTopShop: true,
  isInsider: true,
  description:
    "Time-honored foods at your fingertips. FOND crafts the highest-quality foundational foods like bone broth, tallow, lard, demi-glace, and duck fat, that reclaim vital nourishment lost to modern diets. Our regenerative staples are made by hand and from scratch, exactly like you would at home. By making them deliciously easy to incorporate into any recipe, we help you put nutrient-density back on the menu. Bonne santé!\n\nOur founder Alysa's journey with FOND began out of personal need, after serious digestive issues left her in emergency surgery and soon after, prepping for another. In lieu of a second surgery, Alysa decided to invest in her wellness from the inside out, and along the way discovered the transformative power of bone broth. FOND now offers a full lineup of both infused and unflavored bone broth, tallow, lard, duck fat, and demi-glace. 10 years later, she never needed that second surgery and is a mama to six beautiful boys.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.143Z",
    importedBy: "entity-db-cli",
  },
};
